import { useContext, useEffect, useMemo, useState } from 'react'
import { useParams, Navigate } from "react-router-dom"

import { BarChart } from '@mui/x-charts/BarChart'

import { Box, Typography, Tooltip, IconButton } from '@mui/material'

import SaveAltIcon from '@mui/icons-material/SaveAlt'

import { AppContext } from '/providers/app-context'
import { getTemplateIssueData } from '/providers/templates-api'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-stats'
import Menu from '/components/templates/template-nav-menu'

import DataExportDialog from '/components/data-export-dialog'
import excelExport from '/components/stats/stats-to-excel'
import { enqueueSnackbar } from 'notistack'

const chartSetting = {
  yAxis: [
    {
      label: 'passes issued',
      width: 100,
    },
  ],
}

const TemplateStats = () => {

  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)

  const template = useMemo(() => {return templates.filter(t => t.template_id === templateId)[0]}, [templates, templateId])

  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  if (!loadingTemplates && !template) return <Navigate to="/templates" replace />

  return (
    <PageWrapper title={template ? `Template Statistics (${template.name})` : 'Template Statistics'} HelpText={HelpText} heading={heading} menu={<Menu template={template} />}>
      <Content template={template} />
    </PageWrapper>
  )
}

export default TemplateStats

const Content = ({ template }) => {

  const { apiSource, apiKey } = useContext(AppContext)
  const [issueData, setIssueData] = useState([])
  const [dataExportDialogOpen, setDataExportDialogOpen] = useState(false)

  const getIssueData = async () => {
    const id = await getTemplateIssueData({ apiSource, apiKey, templateId: template.template_id })
    if (id.ok) {
      setIssueData(id.issueData)
    } else {
      enqueueSnackbar({message:id.error,variant:"error"})
    }
  }

  useEffect(() => {
    if (template) getIssueData()
  }, [template])

  if (template) return (
    <>
      <div className='overflow-y-scroll w-screen h-full'>
        <Typography variant="h6" sx={{ p: 2 }}>Pass issue statistics <Tooltip title="Export"><IconButton onClick={() => setDataExportDialogOpen(true)}><SaveAltIcon /></IconButton></Tooltip></Typography>
  
        <Box sx={{ height: "calc(100% - 100px)", width: '100%' }}>
          <BarChart
            dataset={issueData}
            xAxis={[{ scaleType: 'band', dataKey: 'datestamp' }]}
            series={[{ dataKey: 'live', label: 'Live passes issued' }, { dataKey: 'test', label: 'Test passes issued' }]}
            barLabel={item => item.value?.toString()}
            {...chartSetting}
          />
        </Box>
      </div>
      
      <DataExportDialog open={dataExportDialogOpen} setOpen={setDataExportDialogOpen} fileName={`${template.template_id}-issue-statistics`} data={issueData} excelExport={excelExport}/>
    </>
  )
}
